import type { DataPurgeAllowedFlag } from './registry.js';

/** Used when LaunchDarkly has no value yet, or the client is unavailable. Hard delete stays blocked. */
export const dataPurgeAllowedFlagDefault: DataPurgeAllowedFlag = {
  allowed: false,
  enabled: false,
};

export type DataPurgeHardDeleteBlock = 'flag-off' | 'not-allowed';

export const dataPurgeHardDeleteBlockCopy: Record<DataPurgeHardDeleteBlock, { title: string; message: string }> = {
  'flag-off': {
    title: 'Feature flag is off',
    message:
      'The data-purge-allowed feature flag is off for this environment. Enable the feature flag and target allowed users to use this feature.',
  },
  'not-allowed': {
    title: 'Not an allowed user',
    message:
      'The data-purge-allowed feature flag is on, but you are not one of the allowed users to perform a data purge.',
  },
};

/**
 * `null` when hard delete may proceed. Otherwise the banner/error to show.
 * Anything other than `{ enabled: true, allowed: true }` stays blocked.
 */
export function dataPurgeHardDeleteBlock(flag: unknown): DataPurgeHardDeleteBlock | null {
  if (!isFlagObject(flag) || flag.enabled !== true) {
    return 'flag-off';
  }
  if (flag.allowed !== true) {
    return 'not-allowed';
  }
  return null;
}

function isFlagObject(flag: unknown): flag is { enabled?: unknown; allowed?: unknown } {
  return typeof flag === 'object' && flag !== null;
}
